import React, { useState } from 'react';
import { useEffect } from "react";
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import background from '../assets/backgroundTopNew2.png'
import { getEventTypeCounts } from '../services/event-services'
import { CChart } from '@coreui/react-chartjs';
import { refreshAuthToken } from '../services/auth-services';

function Overview() {
  const [allEventData, setAllEventData] = useState()
  const [loading, setLoading] = useState(true)
  
  useEffect(() => {
    const getVenues = async () => { 
        refreshAuthToken().then(token => {
          GetEventStats(token)
        })
       
    }
    getVenues();
  }, [])

  const GetEventStats = (refreshToken) => {
    var mainArray = []
    getEventTypeCounts(refreshToken)
    .then(response => { 
      var responseJson = response.data;
      console.log(responseJson)
        for (var i = 0; i < responseJson.length; i++) {
          mainArray.push(parseInt(responseJson[i].count))
        }
        setAllEventData(mainArray)
        setLoading(false)
    })
  }
 
  const displayAllEventTypeCounts = () => {
    if (loading) {
      return (
        <Spinner />
      )
    } else {
      return (
        <CChart
          type="doughnut"
          data={{
            labels: ['Music', 'Sport', 'Food', 'Other'],
            datasets: [
              {
                backgroundColor: ['#41B883', '#FFFF00', '#00D8FF', '#DD1B16'],
                data: allEventData,
              },
            ],
          }}
          options={{
            plugins: {
              legend: {
                labels: {
                  color: "white",
                }
              }
            },
          }}
        />
      )
    }
  }

  return (
    <Container style={{ backgroundImage: "url(" + background + ")", backgroundRepeat: "no-repeat", backgroundSize: "auto", height: "100vh", backgroundColor: "#091440", backgroundPosition: "top", color: "white" }} fluid>
      <Row>
        <Col md={3}>
          {displayAllEventTypeCounts()}
        </Col>
      </Row>
    </Container>
  );
}

export default Overview